<template>
	<span class="command">{{shell}}<code>{{basePath}}<strong>{{cmd}}{{cmdSuffix}} {{args}}</strong></code></span>
</template>

<script>
export default {
  props:{
    os: { type: String, default: "windows" },
    cmd: { type: String },
    args: { type: String }
  },
  data() {
    return {
      winSep: "\\",
      linSep: "/",
      winPath: "C:\\Programme\\PostgreSQL\\x.y\\bin\\",
      linPath: ""
    }
  },
  computed: {
    basePath: function() {
      return (this.os == "windows") ? this.winPath : this.linPath;
    },
    cmdSuffix: function() {
      return (this.os == "windows") ? ".exe" : "";
    },
    shell: function() {
      return (this.os == "windows") ? "CMD > " : "shell > ";
    }
  }
}

</script>
